import { FileData } from '@/interfaces';
import { DefaultEntity, ReportParams, ShotgunReportEntity } from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class ShotgunReportService extends BaseService<
  'shotgunReport',
  ShotgunReportEntity,
  DefaultEntity
> {
  constructor() {
    super('kits/reports');
  }

  getShotgunReports = (
    params: ReportParams,
  ): Promise<ShotgunReportEntity[]> => {
    return APIService.get(this.path + '/shotgun', { params });
  };

  presignedPdfReport = (payload: {
    sequenceId: string;
  }): Promise<FileData[]> => {
    const { sequenceId } = payload;

    // return APIService.get(
    //   `/kits/${serial}/get-presigned-pdf-shotgun-report`,
    //   {},
    // );

    return APIService.get(
      `/kits/sequences/${sequenceId}/presigned-shotgun-report`,
      {},
    );
  };
}

export const shotgunReportService = new ShotgunReportService();
